import React, { useEffect, useState } from 'react';
import { Badge, Col, Container, Row ,Button, Alert} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import BarChart from './charts/BarChart';
import PieChart from './charts/PieChart';
import inventoryApi from '../api/inventoryApi';
import * as constants from "../constants/CONSTANT";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import moment from "moment"; // Added By Jaseem

const Home = () => {
  const [data, setData] = useState({});
  const [branches , setBranches] = useState([]);
  const [filterValue,setFilterValues] = useState({});
  const [activeScheduler, setActiveScheduler] = useState(null); // Added By Jaseem

  useEffect(() => {
    const fetchData = async () => {
      const rec = await inventoryApi.fetchDashBoardData();
      const fetchBranchData = await inventoryApi.fetchServiceArea();//Added By Farhan Khan on 11-Sep-2025 using for Fetching Branches Record.
      console.log('fetchBranchData',fetchBranchData)

      if(rec){
        setData(rec);
      }else{
        setData({});
      }
      
      if(fetchBranchData){
         setBranches(fetchBranchData);
      }else{
        console.log("Branch wala");
         setBranches([]);
      }
      
    };
    fetchData();
    fetchActiveScheduler();
    
    // Check every 30 seconds for active scheduler
    const interval = setInterval(() => {
      fetchActiveScheduler();
    }, 30000); // 30 seconds

    return () => clearInterval(interval);
  }, []);

  const fetchActiveScheduler = async () => {
    try {
      const activeSchedulers = await inventoryApi.fetchActiveSchedulers();
      if (activeSchedulers && activeSchedulers.length > 0) {
        // Get the first active scheduler (or you can show all)
        setActiveScheduler(activeSchedulers[0]);
      } else {
        setActiveScheduler(null);
      }
    } catch (error) {
      console.error('Error fetching active scheduler:', error);
      setActiveScheduler(null);
    }
  };

  const handleChange = (e) => {
  const { name, value } = e.target;
  
  setFilterValues((prev) => ({...prev,[name]: value }));

  };

  const handleSearch = async () => {
    const result = await inventoryApi.fetchFilterRecordsDashboard(filterValue);
    
    if(result){
      setData(result);
    }else{
      setData({});
    }
  }

console.log('call home page 1',filterValue)
  return (
    <Container>
      {/* Added By Farhan Khan on 11-Sep-2025 Starts Here */}
      <Row>
{localStorage.getItem("userrole") === "SUPER_ADMIN" && (
    <>
      <Col lg={4}>
        <Form.Group className="mx-3" controlId="formBasicperiod">
          <Form.Label className="form-view-label">
            Branch Service Area
          </Form.Label>
          <Form.Select
            name="branch_service_area"
            onChange={handleChange}
          >
            <option value="">--Select Branch Service Area--</option>
            {branches?.map((item) => (
              <option value={item.id} key={item.id}>{item.name}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
      <Col lg={4} style={{ marginTop: "22px" }}>
        <Button variant="success" onClick={handleSearch}>
          <i className="fas fa-search"></i>
        </Button>
      </Col>
     </>
  )}
</Row>

      {/* Added By Farhan Khan on 11-Sep-2025 Ends Here */}
      
      {/* 
        Added By Jaseem Hussain on 19-Nov-2025
        IEP Scheduler Card - Show active scheduler dates 
      */}
      {activeScheduler && (
        <Row className="mb-3">
          <Col lg={12}>
            <Alert variant="warning" className="mb-0" style={{ 
              borderLeft: '4px solid #ffa500',
              backgroundColor: '#fff3cd',
              animation: 'pulse 2s infinite'
            }}>
              <div className="d-flex align-items-center">
                <i className="fa-solid fa-calendar-days fa-2x me-3" style={{ color: '#ffa500' }}></i>
                <div className="flex-grow-1">
                  <h6 className="mb-1" style={{ color: '#856404', fontWeight: 'bold' }}>
                    <i className="fa-solid fa-circle-exclamation me-2"></i>
                    IEP Schedule Active
                  </h6>
                  <p className="mb-0" style={{ color: '#856404' }}>
                    You can create IEP from <strong>{moment(activeScheduler.start_date).format("DD-MM-YYYY")}</strong> to <strong>{moment(activeScheduler.end_date).format("DD-MM-YYYY")}</strong>
                    {activeScheduler.targeted_audience === 'Specific' && (
                      <span className="ms-2">
                        {/* (For Selected Users Only) */}
                      </span>
                    )}
                  </p>
                </div>
                <Link to="/ieps">
                  <Button variant="warning" size="sm">
                    Go to IEP <i className="fa-solid fa-arrow-right ms-1"></i>
                  </Button>
                </Link>
              </div>
            </Alert>
          </Col>
        </Row>
      )}

      <Row>
        <Col lg={3}>
          <Link to="/serviceareas" className="text-decoration-none text-reset">
            <div
              className="p-3 d-flex align-items-center m-3"
              style={{ backgroundColor: 'white', borderLeft: '4px solid #1a293b' }}
            >
              <span className="fa-stack small">
                <i className="fa-solid fa-circle fa-stack-2x" style={{ color: '#1a293b' }}></i>
                <i className="fa-solid fa-building fa-stack-1x" style={{ color: 'white', fontSize: '2rem' }}></i>
              </span>
              <div className="flex-grow-1">
                <h6 className="text-muted mb-1">BRANCHES</h6>
                <h1 className="mb-0 d-inline">{data?.branch}</h1>
                <Badge bg="light" text="dark">
                  Running
                </Badge>
              </div>
            </div>
          </Link>
        </Col>
        <Col lg={3}>
          <Link to="/students" className="text-decoration-none text-reset">
            <div
              className="p-3 d-flex align-items-center m-3"
              style={{ backgroundColor: 'white', borderLeft: '4px solid tomato' }}
            >
              <span className="fa-stack small">
                <i className="fa-solid fa-circle fa-stack-2x" style={{ color: 'tomato' }}></i>
                <i className="fa-solid fa-child-reaching fa-stack-1x" style={{ color: 'white', fontSize: '2rem' }}></i>
              </span>
              <div className="flex-grow-1">
                <h6 className="text-muted mb-1">STUDENTS</h6>
                <h1 className="mb-0 d-inline">{data?.student}</h1>
                <Badge bg="light" text="dark">
                  Total
                </Badge>
              </div>
            </div>
          </Link>
        </Col>
        <Col lg={3}>
          <Link to="/staffmembers" className="text-decoration-none text-reset">
            <div
              className="p-3 d-flex align-items-center m-3"
              style={{ backgroundColor: 'white', borderLeft: '4px solid #198754' }}
            >
              <span className="fa-stack small">
                <i className="fa-solid fa-circle fa-stack-2x" style={{ color: '#198754' }}></i>
                <i className="fa-solid fa-user-tie fa-stack-1x" style={{ color: 'white', fontSize: '2rem' }}></i>
              </span>
              <div className="flex-grow-1">
                <h6 className="text-muted mb-1">STAFF</h6>
                <h1 className="mb-0 d-inline">{data?.staff}</h1>
                <Badge bg="light" text="dark">
                  Active
                </Badge>
              </div>
            </div>
          </Link>
        </Col>
        <Col lg={3}>
          <Link to="/assessments" className="text-decoration-none text-reset">
            <div
              className="p-3 d-flex align-items-center m-3"
              style={{ backgroundColor: 'white', borderLeft: '4px solid #4798b5' }}
            >
              <span className="fa-stack small">
                <i className="fa-solid fa-circle fa-stack-2x" style={{ color: '#4798b5' }}></i>
                <i className="fa-solid fa-list-check fa-stack-1x" style={{ color: 'white', fontSize: '2rem' }}></i>
              </span>
              <div className="flex-grow-1">
                <h6 className="text-muted mb-1">ASSESSMENTS</h6>
                <h1 className="mb-0 d-inline">{data?.assessment}</h1>
                <Badge bg="light" text="dark">
                  In Progress
                </Badge>
              </div>
            </div>
          </Link>
        </Col>
      </Row>
      <Row className="mt-5">
        {/* <Col lg={6} className="text-center">
          <p>Branch wise count</p>
          <div style={{ height: '400px' }}>
            <BarChart />
          </div>
        </Col> */}
        {
          /**
           * RMKM Phase 2 Changes
           * Added by @ali 
           * Date : 24 April 2025
           * Desc : Added service area permission as previously working on sidebar service area tab
           *  */
        }
        {/* {localStorage.getItem("permissions") &&
          (localStorage
            .getItem("permissions")
            .indexOf(constants.VIEW_SERVICE) >= 0 ||
            localStorage.getItem("permissions").indexOf(constants.MODIFY_ALL) >=
            0) ? ( */}
            <Col lg={12} className="text-center">
              <p className="d-block"></p>
              <div className="text-center" style={{ height: '400px' }}>
                <p>Branch wise performance</p>
                <PieChart  />
              </div>
            </Col> 
        {/* ) 
        : (
          ""
        )} */}
      </Row>
    </Container>
  );
};

export default Home;
